import { Injectable } from "@angular/core";
import { ProductDetail } from "../types";
import { StringToJsonConversion } from "../JSON-conversions";
import { DatePipe } from "@angular/common";
import * as numberToWords from "number-to-words";

@Injectable({
    providedIn: 'root',
})
export class CommonFunctions {
    private datePipe!: DatePipe;

    constructor(
        private stringToJsonConversion: StringToJsonConversion) {
        this.datePipe = new DatePipe('en-US'); // You can specify the locale here
    }


    // getsalesOrderItemBreakdownDetails(stringPD: string): ProductDetail {
    //     const productDetail_default = {
    //         description:"",
    //         orderNo: "",
    //         packingDate: "",
    //         expiryDate: "",
    //         batchNo: "",
    //         productCode: ""
    //     }
    //     try {
    //         let productDetails = this.stringToJsonConversion.convertProductDetails(stringPD)
    //         if (productDetails) { return productDetails }
    //         else { return productDetail_default }
    //     } catch (error) {
    //         return productDetail_default
    //     }
    // }

    formatTimestamp(timestamp: string): string {
        if (!timestamp) {
            return "-"
        }

        // Split the timestamp into year, month, day, hours, minutes, and seconds
        try {
            const year = parseInt(timestamp.substring(0, 4), 10);
            const month = parseInt(timestamp.substring(4, 6), 10) - 1; // Month is 0-indexed
            const day = parseInt(timestamp.substring(6, 8), 10);
            const hours = parseInt(timestamp.substring(9, 11), 10);
            const minutes = parseInt(timestamp.substring(12, 14), 10);
            const seconds = parseInt(timestamp.substring(15, 17), 10);

            const date = new Date(year, month, day, hours, minutes, seconds);
            return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
            // return this.datePipe.transform(date, 'MMMM d, yyyy, h:mm:ss a','GMT+05:30') || ''
        } catch (error) {
            console.log(error);
            return timestamp
        }
    }

    convertCurrencyToWord(number: number | string, currency: string = 'LKR', withCents: boolean = false): string {
        // Convert the number to a string
        const numStr = number.toString();

        // Split the string at the decimal point
        const [integerPart, decimalPart] = numStr.split('.');

        const integerString = numberToWords.toWords(integerPart ?? 0)
        const decimalString = numberToWords.toWords(decimalPart ?? 0)



        const currencyDecimalSuffix = this.decimalPartSuffix(currency)

        const convertedDecimalString = withCents ? `and ${decimalString} ${currencyDecimalSuffix}` : ""

        const currencyString = currency === "" ? "" : `${currency}: `

        return `${currencyString} ${integerString} ${convertedDecimalString}`.toUpperCase()
    }

    decimalPartSuffix(currency: string): string {
        if (currency === 'USD') {
            return "cents"
        } else if (currency === 'LKR') {
            return "cents"
        }

        return "cents"
    }

    // private ones: string[] = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    // convertNumberToWords(num: string): string {
    //     // Ensure the number is a string and has leading zeros if necessary
    //     return num.split('').map(digit => this.ones[parseInt(digit, 10)]).join(' ');
    // }

    // getDecimal_and_integerParts_fromNumber(num: number): {integerPart:string, decimalPart:string} {
    //     // Convert the number to a string
    //     const numStr = num.toString();

    //     // Split the string at the decimal point
    //     const [integerPart, decimalPart] = numStr.split('.');

    //     let number ={
    //         integerPart: integerPart ?? "0",
    //         decimalPart: decimalPart ?? "0",
    //     }
    //     // If there's no decimal part, return '0'
    //     if (!decimalPart) {
    //         number.decimalPart = '0';
    //     }

    //     return number;
    //   }

    formatNumber_toThousandSeparators(value: number, decimalPoints: number = 2): string {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimalPoints,
            maximumFractionDigits: 4
        }).format(value);
    }

    sortItemsByProperty(array: any[], property: string): any[] {
        return array.sort((a, b) => {
            if (a[property] < b[property]) {
                return -1;
            }
            if (a[property] > b[property]) {
                return 1;
            }
            return 0;
        });
    }

    roundNumber(number: number, decimals: number = 2): string {
        const decimalPlaces = Math.pow(10, decimals);
        const roundedNumber = Math.round(number * decimalPlaces) / decimalPlaces
        return roundedNumber.toFixed(decimals);
    }

    checkSentence(sentence: string, maximumWordLength: number): boolean {
        // Split the sentence into words
        const words = sentence.split(/\s+/);

        // Check if any word has a length greater than maximumWordLength
        return words.some(word => word.length > maximumWordLength);
    }
}